const init = {
  salesGroup: undefined,
  brand: undefined,
  section: undefined,
  paymentTerms: undefined,
  currency: undefined,
  grade: undefined,
};

export default function reducer(state = init, action) {
  switch (action.type) {
    case "SET_CRITERIA_SALESGROUP": {
      return {
        ...state,
        salesGroup: action.payload,
      };
    }
    case "SET_CRITERIA_GRADE": {
      return {
        ...state,
        grade: action.payload,
      };
    }
    case "SET_CRITERIA_BRAND": {
      return {
        ...state,
        brand: action.payload,
      };
    }
    case "SET_CRITERIA_SECTION": {
      return {
        ...state,
        section: action.payload,
      };
    }
    case "SET_CRITERIA_PAYMENT_TERMS": {
      return {
        ...state,
        paymentTerms: action.payload,
      };
    }
    case "SET_CRITERIA_CURRENCY": {
      return {
        ...state,
        currency: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
